import React              from 'react';
import { reduxForm }      from 'redux-form';
import { useTranslation } from 'react-i18next';

import RenderButton         from '../../buttons/base/RenderButton';
import { RenderEmailField } from '../../fields/redux/RenderEmailField';

const ChangePasswordForm = (props) => {
  const {
          changeTab,
          handleSubmit,
          submitForm,
        } = props;

  const { t } = useTranslation();

  return (
    <form
      name={'ChangePasswordForm'}
      className={'ChangePasswordForm'}
      noValidate={true}
      method={'post'}
      onSubmit={event => submitForm(event, handleSubmit)}
    >
      <fieldset>
        <RenderEmailField name={'email'} label={t('client_set_email')} />
      </fieldset>
      <div>
        <RenderButton type={'submit'} className={'fill'} label={t('btn_send')} />
        <RenderButton label={t('label_authorization')} action={() => changeTab(0)} />
      </div>
    </form>
  );
};

export default reduxForm({
  form:         'ChangePasswordForm',
  validate:     () => {
  },
  onSubmitFail: (errors, dispatch) => {
  },
})(ChangePasswordForm);